document.addEventListener("DOMContentLoaded", function () {
  function initLvCuratedCarousel() {
    var $carousel = $('.lv-curated-grid.owl-carousel');

    if ($carousel.length && !$carousel.hasClass('owl-loaded')) {
      $carousel.owlCarousel({
        items: 3,
        loop: true,
        margin: 32,
        nav: true,
        dots: true,
        autoplay: false,
        smartSpeed: 600,
        navText: [
          '<i class="fa-solid fa-chevron-left"></i>',
          '<i class="fa-solid fa-chevron-right"></i>'
        ],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1024: {
            items: 3
          }
        }
      });
    }
  }

  initLvCuratedCarousel();

  
  document.addEventListener('shopify:section:load', function () {
    initLvCuratedCarousel();
  });


  const header = document.querySelector("#shopify-section-sections--27734417277094__header .header");

  if (header) {
    window.addEventListener("scroll", function () {

      if (window.scrollY > 0) {
        header.classList.add("header-scrolled");
      } else {
        header.classList.remove("header-scrolled");
      }

    });
  }
  

});